import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Prismic from 'prismic-javascript';

class MenuMobileProductsEsEs extends Component {
  state = {
    status: false,
    mdf: [],
    compensados: [],
  }

  componentDidMount = () => {
    const apiEndpoint = 'https://guararapes.cdn.prismic.io/api/v2'
    const Client = Prismic.client(apiEndpoint);
    const fetchData = async () => {
      const response = await Client.query(
        Prismic.Predicates.at('document.type', 'tipo_de_produtos'),
        {lang: 'es-es'}
      )
      if (response) {
        const mdf = [];
        const compensados = [];
        response.results.map((item, index) => {
          switch (item.data.tipo) {
            case 'MDF':
              mdf.push(item);
              break;
            case 'Compensados':
              compensados.push(item);
              break;
            default:
          }
          return true;
        })
        this.setState({'mdf': mdf, 'compensados': compensados});
      }
    }
    fetchData();
  }

  render () {
    const {toggleMenuType} = this.props;
    return (
      <menu>
        <li>
          <span className="arrow-down">Productos</span>
        </li>
        <li>
          <Link to="/produtos/mdf">MDF</Link>
        </li>
        {
          this.state.mdf.map((item, index) => {
            return (
              <li className="small" key={ index }>
                <Link to={ `/produtos/${item.uid}` }>{ item.data.nome[0].text }</Link>
              </li>
            )
          })
        }
        <li>
          <Link to="/produtos/compensados">Plywood</Link>
        </li>
        {
          this.state.compensados.map((item, index) => {
            return (
              <li className="small" key={ index }>
                <Link to={ `/produtos/${item.uid}` }>{ item.data.nome[0].text }</Link>
              </li>
            )
          })
        }
        <li>
          <span className="arrow-left" onClick={ (e) => { toggleMenuType('regular') }}>Vuelve</span>
        </li>
      </menu>
    )
  }
}

MenuMobileProductsEsEs.propTypes = {
  dispatch: PropTypes.func,
  match: PropTypes.object,
  location: PropTypes.object,
};

export default MenuMobileProductsEsEs;
